/**
 * Short chip label for the special-cased webpage types. Returns `null` for every
 * other type so callers render no chip. Single-sourced so the gallery, the Focus
 * Review lightbox, and the inbox stay in lockstep on the authentication → "Login"
 * and llm → "LLM" special-casing.
 */
export function getTypeBadgeLabel(type: string): string | null {
  if (type === 'authentication') return 'Login';
  if (type === 'llm') return 'LLM';
  return null;
}
